export default __webpack_public_path__ + "static/media/offer.c187b0de.png";